import { PRODUCT_INFO } from '@hsc/common/constants/product-info';

export const FAQ_LIST = [
  /*
    * Note: the first FAQ is intentionally not included in this list since it requires special formatting to include the product name within the question and answer text.  If we find we have more FAQs that require special formatting, we should consider a more dynamic solution rather than hardcoding the first FAQ within the template.
  {
    question: `What does a ${PRODUCT_INFO.name} cover?`,
    answer: [
      `The ${PRODUCT_INFO.name} provides repair and replacement coverage for appliances as well as electrical, plumbing and HVAC systems. It complements homeowner’s insurance by covering everyday breakdowns caused by wear and tear that insurance doesn’t cover. The details of a breakdown situation may impact coverage. See <a>Sample Plan</a> for full details and exclusions.`,
    ],
  }, */
  {
    question: `What makes the ${PRODUCT_INFO.name} different?`,
    answer: [
      `It simplifies homeownership by reducing the financial strain of a breakdown and eliminating the stress of finding and vetting a repair technician. Customers can choose to use the contractor network or their own pro to diagnose and repair covered breakdowns. This plan also offers an annual reimbursement for a professional maintenance service, such as an HVAC tune-up, so customers can keep their homes up and running. `,
    ],
  },
  {
    question: 'How is this different from homeowners insurance?',
    answer: [
      `Homeowners insurance protects your home from perils such as fires, theft or natural disasters. This ${PRODUCT_INFO.name} covers everyday breakdowns due to wear and tear that are not covered by homeowners insurance, including appliances and electrical, plumbing and HVAC systems.`,
    ],
  },
  {
    question: `How is a ${PRODUCT_INFO.name} different than Equipment Breakdown coverage?`,
    answer: [
      `Equipment breakdown is an optional insurance add-on to a home insurance policy that typically covers household electronics, equipment and appliances impacted by a mechanical, electrical or pressure systems breakdown. It typically has a higher deductible, can impact a policyholders insurance claim history, and excludes breakdowns caused by normal wear and tear. However, it may provide a higher aggregate limit for covered losses as well as some extra expenses not covered in the Nationwide ${PRODUCT_INFO.name}.`,
      `A ${PRODUCT_INFO.name} is not insurance, and it does not impact insurance claims history. Notably, a ${PRODUCT_INFO.name} does cover breakdowns caused by wear and tear.`,
      `Currently, Nationwide members are restricted from purchasing equipment breakdown insurance and a ${PRODUCT_INFO.name} at the same time (they must choose one or the other).`,
    ],
  },
  {
    question: 'Is there a workmanship guarantee?',
    answer: [
      'Yes! Covered repairs completed by technicians in the repair network are backed by a 120-day parts and labor workmanship guarantee. If the issue returns, a technician will return for free. This does not apply to customer-selected contractors outside of the repair network. ',
    ],
  },
  {
    question: 'How do customers file a home warranty claim or request service? ',
    answer: [
      `File online at nationwide.subscriptionwarranty.com or by calling ${PRODUCT_INFO.phone}.`,
      `If a Covered Product failure causes damage to your home or personal property, you must report any insurance claim directly to your homeowners insurer. Submitting a service request to the Nationwide ${PRODUCT_INFO.name} does not (1) notify any insurer, (2) satisfy any notice or proof of loss requirement, or (3) constitute a request for coverage under any homeowners or condominium policy.`,
    ],
  },
  {
    question: 'Is a Home Warranty service request considered a homeowners insurance claim?',
    answer: [
      `No! The Nationwide ${PRODUCT_INFO.name} is not an insurance product, and home warranty service requests are not considered insurance claims. As a result, a home warranty service request does not impact a customer’s homeowners insurance claim history. `,
      `However, if a covered item failure causes damage to the home or personal property, a separate insurance claim may need to be reported to the customer’s homeowners insurance carrier.`,
    ],
  },
  {
    question: 'Can customers choose their own repair provider?',
    answer: [
      'Yes, if customers do not want to use a technician from the service network, they can choose to use a properly licensed, registered and insured professional of their choice.  Once the repair is complete, customers will be reimbursed for covered repairs, less the plan’s stated service fee. Limitations apply. See sample plan for full explanation of claims process and coverage detail.',
    ],
  },
  {
    question: 'Can customers request service as soon as their plan starts?',
    answer: [
      'As is customary with home warranties, coverage for home systems and appliances begins 30 days after the plan starts. Customers have instant access to the preventative maintenance reimbursement and can receive this benefit right away.',
    ],
  },
  {
    question: 'Is there a service fee?',
    answer: [
      'Yes, a service fee is owed for each service request. If a customer uses a technician from the service network, the service fee will be collected before the technician is dispatched. If a customer uses their own repair provider, the service fee is deducted from the reimbursement amount.*',
      '*Does not apply to preventative maintenance reimbursement or food spoilage coverage.',
    ],
  },

  {
    question: 'How does the preventative maintenance reimbursement work?',
    answer: [
      `The Nationwide ${PRODUCT_INFO.name} is designed to help you prevent future problems by offering an annual maintenance reimbursement each year for a professional HVAC system tune-up, dryer vent cleaning, gutter cleaning, chimney sweep or water heater maintenance. Customers can request reimbursement at nationwide.subscriptionwarranty.com or by calling ${PRODUCT_INFO.phone}.`,
    ],
  },
  {
    question: `How can a ${PRODUCT_INFO.name} be cancelled? `,
    answer: [
      `Customers can cancel their ${PRODUCT_INFO.name} at any time online at nationwide.subscriptionwarranty.com or by calling ${PRODUCT_INFO.phone}. If customers cancel during the 20-day trial period*, they will be refunded 100% of their initial payment, less any paid claims or preventative maintenance (except where prohibited by law). If customers cancel after the 20-day trial period*, they won’t be charged for any future monthly payments, and coverage will remain active until the end of their current billing cycle.`,
      '*Trial period is 30-days in Washington D.C., Hawaii, Illinois, and Texas, as required by state law. ',
    ],
  },
];
